import { Pipe, PipeTransform, OnDestroy } from '@angular/core'
import { OfflineService } from '../offline.service';

@Pipe({
    name: 'offline',
    /**
     * On pure pipes change detection is only run when input changes (not when offline mode changes)
     * This should perform better than the impure counterpart, however some write that 
     * pure pipes are only instiantiated once (per component?). It seems do do the job while being pure both in safari and chrome
     * See chrome://chrome-urls/ -> chrome://blob-internals/ for resource debugging
     */
    pure: true
})

export class OfflinePipe implements PipeTransform, OnDestroy {
    private static initNo = 1;

    // private id = 0;
    private inputUrl: string = "";
    private offlineBlob: string = "";
    private holderBlob: string = "";

    constructor(private offlineService: OfflineService) {
        // this.id = OfflinePipe.initNo++;
        // console.log("Initiate offline pipe ", this.id);
    }

    /**
     * Get the offline version of a url if offline mode is enabled
     * @args First argument is a optional url path to use as place holder resource (image, video, sound etc.) 
     */
    transform(url: string, placeHolderUrl: string = null): Promise<string> {
        // Do nothing if the input dident change
        if(url == this.inputUrl) return Promise.resolve(url);

        return new Promise(async (resolve) => {
            this.destroyBlobUrl();
            // Load offline resource if in offline mode
            let offline = await this.offlineService.loadResourceUrl(url);
            this.offlineBlob = offline.blob;

            // Greate offline url good
            if(offline.url) return resolve(offline.url);

            // Use placholder from input argument or default to image placeholder 
            // (meaning sound and video should always give placeholder as argument (ie. null))
            if(!placeHolderUrl) return resolve("");

            // Load offline place holder version or fallback to origin
            let placeHolderOffline = await this.offlineService.loadResourceUrl(placeHolderUrl, true);
            this.holderBlob = placeHolderOffline.blob;

            resolve(placeHolderOffline.url);
        })
    }

    private destroyBlobUrl() {
        if(!this.holderBlob && !this.offlineBlob) return;

        // Release blob resources
        this.offlineService.deleteBlobUrl(this.offlineBlob);
        this.offlineService.deleteBlobUrl(this.holderBlob);
        this.offlineBlob = "";
        this.holderBlob = "";
    }

    ngOnDestroy() {
        this.destroyBlobUrl();
    }
}
